import React from 'react';
import { WebsiteNavbar } from './WebsiteNavbar';
import { WebsiteFooter } from './WebsiteFooter';
import { Linkedin, Mail, Quote } from 'lucide-react';

const WebsiteEquipe = () => {
  // Données reprises fidèlement du site syndicappli.fr
  const founders = [
    {
      name: 'Thierry ROY',
      role: 'Président fondateur',
      age: '41 ans',
      image: 'https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/elementor/thumbs/TROY_PROFIL_ROUND_PROFIL_PICTURE_SMALL_HD_NEW-q6cm4yv1addwu3h3te8m0qt00pp6tj8rqmjq4vhgdc.png?w=750&ssl=1',
      bio: [
        '15 années en tant que président et membre de CS',
        '15 ans d\'expérience en Design et Communication évènementielle',
        'Dirigeant de la société d\'Architecture ARCHFX de 2016 à 2018 spécialisée dans l\'immobilier'
      ],
      linkedin: '#'
    },
    {
      name: 'Jacques MATTI',
      role: 'Directeur général',
      age: '50 ans',
      image: 'https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/05/JacquesMatti.png?resize=208%2C208&ssl=1',
      bio: [
        '20 ans d\'expérience en tant que gestionnaire',
        'Directeur de cabinet chez Billot & Girardot pendant 3 ans',
        'Dirigeant fondateur du Cabinet SYGIL IMMOBILIER',
        'Ancien Gestionnaire de copropriété chez : Foncia Paris, Loiselet & Daigremont, Cabinet Gelis, Cabinet Ertim'
      ],
      linkedin: '#'
    }
  ];

  const values = [
    {
      title: 'Innovation',
      description: 'Nous repoussons les limites de la technologie pour simplifier votre quotidien.'
    },
    {
      title: 'Proximité',
      description: 'Une équipe à l\'écoute, disponible et réactive pour vous accompagner.'
    },
    {
      title: 'Excellence',
      description: 'Un engagement qualité dans chaque fonctionnalité développée.'
    },
    {
      title: 'Confiance',
      description: 'Sécurité des données et transparence sont nos priorités absolues.'
    }
  ];

  return (
    <div className="min-h-screen bg-white" data-testid="website-equipe">
      <WebsiteNavbar />

      {/* Hero */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            L'équipe derrière SyndicAppli
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            Une équipe passionnée qui travaille chaque jour pour révolutionner la gestion de copropriété.
          </p>
        </div>
      </section>

      {/* Founders */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <img 
              src="https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/05/Logo-Syndicappli_Gradient_2022.png?resize=300%2C63&ssl=1"
              alt="SyndicAppli"
              className="h-16 mx-auto mb-8"
            />
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              L'équipe dirigeante
            </h2>
            <p className="text-lg text-slate-500">
              Deux entrepreneurs unis par une vision commune
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
            {founders.map((founder, index) => (
              <div
                key={index}
                data-testid={`founder-card-${index}`}
                className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-xl transition-shadow"
              >
                <div className="p-8 flex flex-col items-center">
                  {/* Photo ronde */}
                  <div className="w-48 h-48 rounded-full overflow-hidden bg-gradient-to-br from-[#00D3A8]/10 to-[#00B894]/10 mb-6 border-4 border-[#00D3A8]/20">
                    <img
                      src={founder.image}
                      alt={founder.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `<div class="w-full h-full bg-[#00D3A8] flex items-center justify-center text-white text-5xl font-bold">${founder.name.charAt(0)}</div>`;
                      }}
                    />
                  </div>
                  
                  {/* Infos */}
                  <h3 className="text-2xl font-bold text-slate-800 mb-1">{founder.name}</h3>
                  <p className="text-[#00D3A8] font-semibold mb-1">{founder.role}</p>
                  <p className="text-slate-500 text-sm mb-6">{founder.age} – Associé</p>
                  
                  {/* Bio sous forme de liste */}
                  <ul className="text-slate-600 text-sm space-y-2 text-left w-full">
                    {founder.bio.map((item, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#00D3A8] mt-1">●</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  
                  {/* Social links */}
                  <div className="flex gap-3 mt-6">
                    <a
                      href={founder.linkedin}
                      className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center hover:bg-[#00D3A8] hover:text-white transition-colors text-slate-500"
                    >
                      <Linkedin className="w-5 h-5" />
                    </a>
                    <a
                      href={`mailto:contact@syndicappli.fr`}
                      className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center hover:bg-[#00D3A8] hover:text-white transition-colors text-slate-500"
                    >
                      <Mail className="w-5 h-5" />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote - Notre ADN */}
      <section className="py-20" style={{ background: 'linear-gradient(135deg, #00D3A8 0%, #00B894 100%)' }}>
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Notre ADN
          </h2>
          <Quote className="w-12 h-12 text-white/30 mx-auto mb-6" />
          <blockquote className="text-xl md:text-2xl font-medium text-white mb-8 leading-relaxed">
            L'histoire de Syndicappli s'inscrit tout d'abord dans une démarche personnelle et une envie 
            incroyable de faire bouger les lignes. Le métier de syndic a besoin de solutions adaptées 
            à son quotidien, Syndicappli en a fait son cheval de bataille, c'est notre ADN.
          </blockquote>
          <p className="text-white/80 text-lg font-medium">L'innovation, notre philosophie.</p>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Nos valeurs
            </h2>
            <p className="text-lg text-slate-500">
              Les principes qui guident chacune de nos actions
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 text-center shadow-sm border border-slate-100 hover:shadow-lg hover:border-[#00D3A8]/30 transition-all"
              >
                <div className="w-16 h-16 rounded-full bg-[#00D3A8]/10 flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold text-[#00D3A8]">{index + 1}</span>
                </div>
                <h3 className="text-xl font-semibold text-slate-800 mb-3">{value.title}</h3>
                <p className="text-slate-500">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Story */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-8 text-center" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Notre histoire
          </h2>
          <div className="prose prose-lg max-w-none text-slate-600 space-y-6">
            <p className="text-lg leading-relaxed">
              SyndicAppli est née d'un constat simple : la gestion de copropriété était restée à l'ère du papier 
              alors que tous les autres secteurs se digitalisaient. Thierry et Jacques ont décidé de 
              créer l'outil qu'ils auraient aimé avoir pour révolutionner le métier de syndic.
            </p>
            <p className="text-lg leading-relaxed">
              Incubés à <strong>Laval Mayenne Technopole</strong> et soutenus par <strong>BPI France</strong>, 
              nous avons développé une solution pensée par et pour les professionnels de l'immobilier. 
              Après <strong>24 mois de développement</strong> et plus de <strong>7530 cafés consommés</strong>, 
              SyndicAppli est aujourd'hui utilisée par des centaines de syndics à travers la France.
            </p>
            <p className="text-lg leading-relaxed">
              Notre application, ultra sécurisée et conforme RGPD, vous permet de créer, d'organiser, 
              gérer et tenir toutes vos assemblées générales hybrides en quelques clics. 
              Notre ambition ? Devenir la référence de la gestion de copropriété en France.
            </p>
          </div>
        </div>
      </section>

      {/* Incubator / Partners */}
      <section className="py-16 bg-slate-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <p className="text-center text-slate-400 mb-8">Incubé et soutenu par</p>
          <div className="flex flex-wrap items-center justify-center gap-12">
            <img
              src="https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/04/Logos_Trampoleen_Site_250x80.png?resize=250%2C80&ssl=1"
              alt="Trampoleen"
              className="h-10 opacity-60 hover:opacity-100 transition-opacity"
            />
            <img
              src="https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/04/Logos_LMT_Site_250x80.png?resize=250%2C80&ssl=1"
              alt="Laval Mayenne Technopole"
              className="h-10 opacity-60 hover:opacity-100 transition-opacity"
            />
            <img
              src="https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/04/Logos_UP_Site_250x80.png?resize=250%2C80&ssl=1"
              alt="UP"
              className="h-10 opacity-60 hover:opacity-100 transition-opacity"
            />
            <img
              src="https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/04/Logos_Idenergie_Site_250x80.png?resize=250%2C80&ssl=1"
              alt="Idenergie"
              className="h-10 opacity-60 hover:opacity-100 transition-opacity"
            />
            <img
              src="https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/04/Logos_LavalAgglo_Site_250x80.png?resize=250%2C80&ssl=1"
              alt="Laval Agglomération"
              className="h-10 opacity-60 hover:opacity-100 transition-opacity"
            />
            <img
              src="https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/04/Logos_PaysDeLaLoire_Site_250x80.png?resize=250%2C80&ssl=1"
              alt="Pays de la Loire"
              className="h-10 opacity-60 hover:opacity-100 transition-opacity"
            />
            <img
              src="https://i0.wp.com/www.syndicappli.fr/wp-content/uploads/2023/04/Logos_InitiativeMayenne_Site_250x80.png?resize=250%2C80&ssl=1"
              alt="Initiative Mayenne"
              className="h-10 opacity-60 hover:opacity-100 transition-opacity"
            />
          </div>
        </div>
      </section>

      <WebsiteFooter />
    </div>
  );
};

export { WebsiteEquipe };
